import React from 'react';
import { CalendarIcon, TruckIcon, HeartIcon } from 'lucide-react';
export function Hero() {
  return <section className="w-full bg-gradient-to-b from-pink-50 to-white py-12 md:py-16" data-id="element-207">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-208">
        <div className="flex flex-col md:flex-row items-center justify-between" data-id="element-209">
          <div className="md:w-3/5 mb-8 md:mb-0 md:pr-10" data-id="element-210">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 leading-tight" data-id="element-211">
              Fresh Flowers, <span className="text-pink-700" data-id="element-212">Delivered</span> on
              Your Schedule
            </h1>
            <p className="mt-4 text-lg text-gray-600 max-w-2xl" data-id="element-213">
              Never forget another special date. Kenya's first tech-driven
              flower subscription service for homes, relationships, and
              businesses.
            </p>
            <div className="mt-6 flex flex-col sm:flex-row gap-4" data-id="element-214">
              <button className="px-6 py-2 bg-pink-700 text-white rounded-md text-base font-medium hover:bg-pink-800 transition-colors" data-id="element-215">
                Start Your Subscription
              </button>
              <button className="px-6 py-2 border border-gray-300 text-gray-700 rounded-md text-base font-medium hover:bg-gray-50 transition-colors" data-id="element-216">
                Shop Now
              </button>
            </div>
            <div className="mt-8 flex flex-wrap gap-6" data-id="element-217">
              <div className="flex items-center" data-id="element-218">
                <div className="mr-2 p-2 bg-pink-100 rounded-full" data-id="element-219">
                  <CalendarIcon className="h-4 w-4 text-pink-700" data-id="element-220" />
                </div>
                <span className="text-sm text-gray-700" data-id="element-221">Never miss a date</span>
              </div>
              <div className="flex items-center" data-id="element-222">
                <div className="mr-2 p-2 bg-pink-100 rounded-full" data-id="element-223">
                  <TruckIcon className="h-4 w-4 text-pink-700" data-id="element-224" />
                </div>
                <span className="text-sm text-gray-700" data-id="element-225">Reliable delivery</span>
              </div>
              <div className="flex items-center" data-id="element-226">
                <div className="mr-2 p-2 bg-pink-100 rounded-full" data-id="element-227">
                  <HeartIcon className="h-4 w-4 text-pink-700" data-id="element-228" />
                </div>
                <span className="text-sm text-gray-700" data-id="element-229">Personalized care</span>
              </div>
            </div>
          </div>
          <div className="md:w-2/5 flex justify-center" data-id="element-230">
            <div className="relative max-w-sm" data-id="element-231">
              <div className="absolute -top-4 -right-4 bg-white px-3 py-1 rounded-full shadow-md text-pink-700 font-medium text-sm" data-id="element-232">
                New Arrivals
              </div>
              <img src="https://images.unsplash.com/photo-1508610048659-a06b669e3321?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=600&q=80" alt="Beautiful flower arrangement" className="rounded-lg shadow-lg object-cover h-[450px]" data-id="element-233" />
              <div className="absolute -bottom-4 -left-4 bg-white p-3 rounded-lg shadow-md" data-id="element-234">
                <div className="flex items-center space-x-2" data-id="element-235">
                  <div className="flex -space-x-2" data-id="element-236">
                    <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&auto=format&fit=crop&w=60&q=80" alt="Customer" className="w-8 h-8 rounded-full border-2 border-white object-cover" data-id="element-237" />
                    <img src="https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?ixlib=rb-4.0.3&auto=format&fit=crop&w=60&q=80" alt="Customer" className="w-8 h-8 rounded-full border-2 border-white object-cover" data-id="element-238" />
                  </div>
                  <div className="text-xs" data-id="element-239">
                    <p className="font-medium text-gray-900" data-id="element-240">
                      200+ Happy Customers
                    </p>
                    <div className="flex items-center text-amber-500" data-id="element-241">
                      <span data-id="element-242">★★★★★</span>
                      <span className="text-gray-600 ml-1" data-id="element-243">(4.9)</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}